export default [
  {
    'text': 'SMS',
    'state': 'SMS'
  },
  {
    'text': 'LMS',
    'state': 'LMS'
  },
];



// WEBPACK FOOTER //
// ./src/api/msgType.js